module.exports = __webpack_public_path__ + "static/img/f1.ad573a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f1.png
// module id = mrPq
// module chunks = 1